<div class="row title-container align-items-center mb-5" style="padding: 10px;">
    <img src="./assets/icons/arrow-left.svg" style="margin-right: 10px; cursor: pointer;" (click)="back()">
    <img src="./assets/icons/arrow.svg">
    <span class="label-title ml-2 mr-3">Favorecidos Grupo {{ group.name }}</span>
</div>
<div class="row">

<div class="row cards">
    <div class="col-md-12 text-right" *ngIf="!isMobile">

        <ul class="options-cadastro">
            <li>
                <div *ngIf="exibirFiltro && filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                    my-1">
                    <button _ngcontent-khv-c20="" class="list-select-delete" type="button">
                        Apagar filtro
                    </button>
                </div>
            </li>
            <li>
                <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                    my-1">
                    <button _ngcontent-khv-c20="" class="list-select"  type="button">
                        <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                        <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                    </button>
                </div>
            </li>
            <li>
                <div class="list-select-search-input ml-2 my-1">
                    <input class="w-100 ng-untouched ng-pristine
                        ng-valid" placeholder="Pesquise aqui..." type="search" [(ngModel)]="filtroPesquisa" (keyup.enter)="callGroupCollaborator(1)" autocomplete="off"/>
                </div>
            </li>
            <li>
                <div class="list-filter-show-item ml-2 my-1">
                    Mostrar:
                    <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                        <option _ selected="" value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
            </li>
        </ul>
    </div>
    <div style="margin: 30px 0 15px 15px; display: block;" class="title">
        <div *ngFor="let item of groupCollaborators | paginate: { id: 'pagination', itemsPerPage: showItem, currentPage: page, totalItems: totalItems } " class="row container-dados" style="position: relative;" >
            <div class="identificador"> <p class="identificador-letra"> {{ item.collaboratorName.charAt(0) }} </p> </div>
            <div class="colaborador-info">
                <span style="font-weight: 510;">{{ item.collaboratorName }}</span>
                <span style="font-size: 10px;">CPF: {{ item.collaboratorDocument | cpf }}</span>
            </div>
            <div ngbDropdown placement="left" class="button-detalhes d-inline-block menu-option button-mobile">
                <button type="button" class="btn dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                    <img src="./assets/icons/menu.png" >
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                    <section class="custom-context-menu">
                        <div ngbDropdownItem (click)="removerGrupo(item)">
                            <img src="assets/icons/remove.svg" class="mr-2 option-btn-group" />Remover do grupo
                        </div>

                        <div ngbDropdownItem (click)="moverGrupo(moverModal, item)">
                            <img src="assets/icons/open-transfer.svg" class="mr-2 option-btn-group" />Mover para outro grupo
                        </div>
                    </section>
                </div>
            </div>
            <div class="title" style="margin-bottom: 10px;">
                <hr />
            </div>
        </div>
        <div class="page-custom">
            <pagination-controls id="pagination" responsive="true" previousLabel="" nextLabel="" (pageChange)="callGroupCollaborator($event)"></pagination-controls>
        </div>
    </div>
</div>

<ng-template #moverModal let-modal>
    <div class="col-12" style="margin: 15px;">
        <button id="buttonCloseModal" type="button" class="btn right" style="background-color: #fff; border: none;" (click)="modal.dismiss()">
            <img src="./assets/icons/X.png">
        </button>
    </div>
    <div class="custom-modal row mx-5 modal-background">
        <div class="row align-items-center modal-header-title mb-5" style="padding-top: 30px; display: block;">
            <div>
                <img src="./assets/icons/arrow.svg">
                <span class="label-title ml-2 mr-3">Mover para outro grupo</span>
            </div>
            <div style="padding-top: 15px;">
                <span style="font-family: ubuntu; font-size: 10px;">Mover {{ selectedItem.collaboratorName }}, selecione o grupo</span>
            </div>
        </div>
        <div style="margin: 0px 0 15px 15px; display: block;" class="title">
            <div *ngFor="let item of groups" class="row container-dados container-dados-modal" style="position: relative;" >
                <input style="margin-right: 30px;" [checked]="item.selecionado" (change)="selectElement(item)" type="radio" id={{item.id}}>
                <div class="span-container mr-3">
                    {{ item.name.charAt(0) }}
                </div>
                <div class="colaborador-info">
                    <span style="font-weight: 510;">{{ item.name }}</span>
                    <span style="font-size: 10px;">{{ item.countCollaborators }} favorecidos</span>
                </div>
                <div class="title" style="margin-bottom: 10px;">
                    <hr />
                </div>
            </div>
        </div>
        <div class="title" style="padding: 30px;">
            <button (click)="finalizar()" class="action-button-modal right" style="margin-bottom: 30px;">Finalizar</button>
        </div>
    </div>
</ng-template>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
    <div class="col-12 modal-header clean-modal-header">
        <div class="col-md-12">
            <h5 class="clean-modal-title">Aplicar filtro</h5>
        </div>
    </div>
    <div class="row col-12 clean-modal-content">
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field class="example-form-field">
                    <input [formControl]="nameCtrl" matInput type="text" placeholder="Nome" [(ngModel)]="filtroNome">
                    <button mat-button *ngIf="filtroNome" matSuffix mat-icon-button aria-label="Clear" (click)="filtroNome=''">
                        <mat-icon>close</mat-icon>
                    </button>
                    </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field class="example-form-field">
                    <input [formControl]="documentCtrl"  matInput type="text" placeholder="CPF" [(ngModel)]="filtroCPF">
                    <button mat-button *ngIf="filtroCPF" matSuffix mat-icon-button aria-label="Clear" (click)="filtroCPF=''">
                        <mat-icon>close</mat-icon>
                    </button>
                    </mat-form-field>
            </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field class="example-form-field">
                    <input [formControl]="registerCtrl" matInput type="text" placeholder="{{ labelMatricula }}" [(ngModel)]="filtroMatricula">
                    <button mat-button *ngIf="filtroMatricula" matSuffix mat-icon-button aria-label="Clear" (click)="filtroMatricula=''">
                        <mat-icon>close</mat-icon>
                    </button>
                    </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="costCenterCtrl" id="centroCusto" [multiple]="true" placeholder="{{ labelCentroCusto }}" [value]="filtroCentroCusto">
                        <mat-option *ngFor="let item of centrosCustosList" [value]="item.centroCustoId">
                            {{item.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="unitCtrl" id="unidade" [multiple]="true" placeholder="{{ labelUnidade }}" [value]="filtroUnidade">
                        <mat-option *ngFor="let item of unidadesList" [value]="item.unidadeId">
                            {{item.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>

        <div class="col-lg-4 col-md-6 col-sm-12 my-4">
            <div class="custom-filter-input-container">
                <mat-form-field>
                    <mat-select [formControl]="departmentCtrl" id="departamento" [multiple]="true" placeholder="{{ labelDepartamento }}" [value]="filtroDepartamento">
                        <<mat-option *ngFor="let item of departamentosList" [value]="item.departamentoId">
                            {{item.nome}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="col-12 clean-modal-footer">
        <button class="custom-filter-button custom-filter-button-just" type="button" (click)="
                applyFilter();
                modal.dismiss('Close click')
            " ngbAutofocus>
            Aplicar
        </button>
    </div>
</ng-template>
